import React from "react";
import styles from "./MiniFaq.module.css";

function MiniFaq() {
  const data = [
    {
      question: "¿Puedo hacerte un encargo personalizado?",
      answer: "¡Claro que sí!",
    },
  ];
  return (
    <div className={styles.container}>
      <p>Respuestas rápidas</p>
      {data.map(({ question, answer }) => (
        <div className={styles.text}>
          <p className={styles.question}>{question}</p>
          <p className={styles.answer}>{answer}</p>
        </div>
      ))}
    </div>
  );
}

export { MiniFaq };
